import { Table } from "antd";
import styles from "../../shared/Evaluaciones.module.css";

export function DetalleRubrosEvaluacion({ rubros }) {
  const columns = [
    {
      title: "Rubro",
      dataIndex: "nombreRubro",
      render: nombre => <strong>{nombre}</strong>,
    },
    {
      title: "Valor registrado",
      dataIndex: "valorDelMomento",
      width: 160,
      render: valor => <span className={styles.mono}>{valor}</span>,
    },
    {
      title: "Cumple",
      dataIndex: "siCumple",
      width: 110,
      render: siCumple => (
        <strong className={`${styles.mono} ${siCumple ? "" : styles.failedAnswer}`}>
          {siCumple ? "SÍ" : "NO"}
        </strong>
      ),
    },
  ];

  return (
    <section className={styles.section}>
      <div className={styles.sectionHeading}>
        <h2>Rubros de la evaluación</h2>
        <span>{rubros.length} RUBROS</span>
      </div>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={rubros}
        pagination={false}
        scroll={{ x: 600 }}
      />
    </section>
  );
}
